import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import stat_blue_gal from "../images/stat_blue_gal.svg";
import platforms_item_image from "../images/platforms_item_image.png";

const PlatformsItem = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [clamped, setClamped] = useState(true);

    const toggleDescription = () => {
        if (isExpanded) {
            setIsExpanded(false);
            setTimeout(() => setClamped(true), 600); // чтобы анимация завершилась перед клэмпингом
        } else {
            setClamped(false);
            setIsExpanded(true);
        }
    };

    const descClasses = `platforms_desc ${isExpanded ? "expanded" : ""} ${clamped ? "clamped" : ""}`;


    const statVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    };

    return (
        <motion.div
            className="platforms_item"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <div className="platforms_item_details">
                <motion.div
                    className="platform_name"
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    SafeUa Foundation
                </motion.div>

                <motion.div
                    className={descClasses}
                    onClick={toggleDescription}
                    layout
                >
                    SafeUa Foundation is a non-profit charitable organization dedicated to ensuring the safety,
                    protection, and comprehensive support of affected citizens of Ukraine.
                    Our mission is to restore a sense of security and provide necessary assistance to those
                    whose lives have been disrupted by the conflict. We strive to be a reliable shield (as symbolized
                    by our logo) for Ukrainians, creating a space where safety and support are paramount.
                </motion.div>

                <motion.div
                    className="platforms_item_statistic"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={{
                        visible: { transition: { staggerChildren: 0.2 } }
                    }}
                >
                    {[
                        { quantity: "$2.5M+", name: "Funds raised" },
                        { quantity: "32+", name: "Supported projects" },
                        { quantity: "120+", name: "Partners joined" },
                        { quantity: "5,200+", name: "Active donors" },
                    ].map((stat, index) => (
                        <motion.div
                            key={index}
                            className="platforms_item_statistic_point"
                            variants={statVariants}
                        >
                            <img src={stat_blue_gal} alt=""/>
                            <div className="points_quantity">{stat.quantity}</div>
                            <div className="points_name">{stat.name}</div>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div
                    className="platforms_item_buttons"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                >
                    <div className="similar_platform_button">
                        Create a similar platform
                    </div>
                    <div className="visit_site_button">
                        Visit site
                    </div>
                </motion.div>
            </div>

            <motion.div
                className="platforms_item_image"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <img src={platforms_item_image} alt=""/>
            </motion.div>
        </motion.div>
    );
};

export default PlatformsItem;
